<template>
    <IframePlayer :sourceUrl="sourceUrl" />
</template>

<script>
    import IframePlayer from './IframePlayer'

    export default {
        components: {
            IframePlayer,
        },

        props: {
            video: { type: Object, required: true },
            autoplay: { type: Boolean, default: false },
        },

        computed: {
            videoId() {
                return this.video.video_host_id
            },

            sourceUrl() {
                return `https://player.vimeo.com/video/${this.videoId}?autoplay=${+this.autoplay}`
            },
        }
    }
</script>